var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2467_14766)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2467_14766",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2467_14766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1997 27.2797L30.1063 42.373C29.8596 42.6202 29.5666 42.8164 29.244 42.9502C28.9214 43.084 28.5756 43.1529 28.2263 43.1529C27.8771 43.1529 27.5313 43.084 27.2087 42.9502C26.8861 42.8164 26.593 42.6202 26.3463 42.373L18.7997 34.8264C18.5528 34.5795 18.3569 34.2864 18.2233 33.9638C18.0897 33.6412 18.021 33.2955 18.021 32.9464C18.021 32.5972 18.0897 32.2515 18.2233 31.9289C18.3569 31.6063 18.5528 31.3133 18.7997 31.0664C19.0466 30.8195 19.3397 30.6236 19.6622 30.49C19.9848 30.3564 20.3305 30.2876 20.6797 30.2876C21.0288 30.2876 21.3746 30.3564 21.6971 30.49C22.0197 30.6236 22.3128 30.8195 22.5597 31.0664L28.213 36.7197L41.413 23.5197C41.6597 23.2725 41.9527 23.0764 42.2753 22.9426C42.5979 22.8087 42.9438 22.7399 43.293 22.7399C43.6423 22.7399 43.9881 22.8087 44.3107 22.9426C44.6333 23.0764 44.9263 23.2725 45.173 23.5197C46.2397 24.5597 46.2397 26.2397 45.1997 27.2797ZM10.6663 31.9997C10.6663 25.7864 13.3863 20.213 17.653 16.3197L21.733 20.3997C21.921 20.584 22.1593 20.7085 22.418 20.7575C22.6766 20.8066 22.944 20.778 23.1864 20.6753C23.4288 20.5726 23.6353 20.4005 23.7801 20.1806C23.9248 19.9607 24.0012 19.7029 23.9997 19.4397V7.9997C23.9997 7.25304 23.413 6.66637 22.6663 6.66637H11.2263C10.0263 6.66637 9.43967 8.10637 10.293 8.93304L13.8663 12.533C8.63967 17.3864 5.33301 24.293 5.33301 31.9997C5.33301 44.6664 14.1863 55.2797 26.0263 57.9997C27.7063 58.373 29.333 57.1197 29.333 55.3864C29.333 54.133 28.453 53.0664 27.2263 52.773C17.7597 50.613 10.6663 42.133 10.6663 31.9997ZM58.6663 31.9997C58.6663 19.333 49.813 8.7197 37.973 5.9997C36.293 5.62637 34.6663 6.8797 34.6663 8.61304C34.6663 9.86637 35.5463 10.933 36.773 11.2264C46.2397 13.3864 53.333 21.8664 53.333 31.9997C53.333 38.213 50.613 43.7864 46.3463 47.6797L42.2663 43.5997C42.0784 43.4154 41.84 43.2909 41.5814 43.2419C41.3228 43.1928 41.0554 43.2215 40.813 43.3241C40.5706 43.4268 40.364 43.5989 40.2193 43.8188C40.0745 44.0387 39.9981 44.2965 39.9997 44.5597V55.9997C39.9997 56.7464 40.5863 57.333 41.333 57.333H52.773C53.973 57.333 54.5597 55.893 53.7063 55.0664L50.133 51.4664C55.3597 46.613 58.6663 39.7064 58.6663 31.9997Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2467_14766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/assignIcon.d5816ff8d062258b0256d85c574c57ad.svg";
export { ForwardRef as ReactComponent };